import './Paging.css'
import Pagination from "react-js-pagination"

function Paging({ page, count, setPage }) { 
    return ( 
        <>
            <Pagination 
                activePage={ page }
                itemsCountPerPage={ 10 }
                totalItemsCount={ count }
                pageRangeDisplayed={ 5 }
                prevPageText={ "이전" }
                nextPageText={ "다음" }
                firstPageText={ "처음" }
                lastPageText={ "끝" }
                onChange={ setPage }
            /> 
        </>
    )
}

export default Paging;
